const prod = {
    apiGateway: {
        API_URL: "https://lasopp-api102.touchsoft.no/api"
    }
};

const stage = {
    apiGateway: {
        API_URL: "https://lasopp-api102.touchsoft.no/api"
    }
};

const dev = {
    apiGateway: {
        API_URL: "https://localhost:44381/api"
    }
};

export function getAppSettings() {
    if (process.env.REACT_APP_ENV !== undefined && process.env.REACT_APP_ENV.toString().trim() === "production") {
        return prod;
    }
    else if (process.env.REACT_APP_ENV !== undefined && process.env.REACT_APP_ENV.toString().trim() === "staging") {
        return stage;
    }
    else {
        return dev;
    }
}

export function getAppEnviromentSettings() {
    if (process.env.REACT_APP_ENV !== undefined && process.env.REACT_APP_ENV.toString().trim() === "production") {
        return 'prod';
    }
    else if (process.env.REACT_APP_ENV !== undefined && process.env.REACT_APP_ENV.toString().trim() === "staging") {
        return 'stage';
    }
    else {
        return 'dev';
    }
}